import { ACTIVE_SERVER_ID } from 'mk/settings';
import { ID_RE, SLUG_RE } from 'mk2/helpers/urls';

const STROLLER_SLUG = `:slug(${SLUG_RE})`;
const BRAND_SLUG = `:slug(${SLUG_RE})`;
const REVIEW_ID = `:reviewId(${ID_RE})`;

const strollersPrefixes = {
    201: '/kocikopedia',
    202: '/kocarkopedie',
    207: '/strollers',
};
const strollersPrefix = strollersPrefixes[ACTIVE_SERVER_ID];

export const strollersUrl = `${strollersPrefix}/`;

export const strollersSearchUrl = `${strollersPrefix}/search/:pageMode(edit|results|all)/`;

export const strollersWishlistUrl = `${strollersPrefix}/wishlist/`;

export const strollersListUrl = `${strollersPrefix}/brand/${BRAND_SLUG}/`;

export const strollersAddReviewUrl = `${strollersPrefix}/${STROLLER_SLUG}/add_review/`;
export const strollersAddReviewScoreUrl = `${strollersPrefix}/${STROLLER_SLUG}/add_review/:screen(score)/`;
export const strollersReviewUrl = `${strollersPrefix}/${STROLLER_SLUG}/review/${REVIEW_ID}/`;
export const strollersReviewsUrl = `${strollersPrefix}/${STROLLER_SLUG}/reviews/`;

export const strollersAddQuestionUrl = `${strollersPrefix}/${STROLLER_SLUG}/add_question/`;

export const strollersDetailUrl = `${strollersPrefix}/${STROLLER_SLUG}/`;
export const strollersDetailAlternateUrl = (server) => `${strollersPrefixes[server]}/${STROLLER_SLUG}/`;
